import DeviceTable from 'components/Device';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';
import './index.scss';

export const Devices = () => {

	const fetchedUserPermission = useSelector(
		(state: any) => state?.userProfile?.data?.permissions
	);
	const isDevicePermission = checkPermission(fetchedUserPermission, {
		permissionName: 'Device',
		permission: ['view'],
	});
	
	return (
		<div>
			
			{isDevicePermission && <DeviceTable />}
		</div>
	);
};
